import React, { useMemo } from 'react';
import { TranslateScope } from '@pegasus/translation';
import { getGA4Context } from '@browsing/tracking';
import { findCategoryById } from '../helpers';
import { CategoryList } from '../categories';
export var CrossCampaignCategoryList = function (_a) {
    var allCategories = _a.allCategories, _b = _a.selectableCategories, selectableCategories = _b === void 0 ? allCategories : _b, _c = _a.isRootCategoryToggleDisabled, isRootCategoryToggleDisabled = _c === void 0 ? false : _c, selectedCategories = _a.selectedCategories, resetSelectedCategories = _a.resetSelectedCategories, handleSelectedCategories = _a.handleSelectedCategories, preExpandedCategories = _a.preExpandedCategories, resetPreExpandedCategories = _a.resetPreExpandedCategories, setSelectedCategory = _a.setSelectedCategory, onRedirectToCatalog = _a.onRedirectToCatalog, _d = _a.translationScope, translationScope = _d === void 0 ? 'catalog' : _d, trackingContext = _a.trackingContext;
    var setVisibilityFilterMultiCategorySelect = function (_, _isWithoutHashMeta, shouldSave) {
        if (!shouldSave) {
            resetPreExpandedCategories();
            resetSelectedCategories();
            return;
        }
        if (!selectedCategories.length) {
            return;
        }
        onRedirectToCatalog(selectedCategories.map(function (_a) {
            var id = _a.id;
            return id;
        }));
    };
    var updateFilter = function (filter) {
        var categoryId = filter.categories[0];
        var foundCategory = findCategoryById({
            category: allCategories,
            id: categoryId,
        });
        setSelectedCategory(foundCategory);
    };
    var isCategorySelected = !!preExpandedCategories.level1;
    var selectedCategoriesIds = selectedCategories.map(function (_a) {
        var id = _a.id;
        return id;
    });
    var sumTotalArticleCount = function () {
        if (selectedCategories.length) {
            return selectedCategories.reduce(function (acc, _a) {
                var count = _a.count;
                return acc + count;
            }, 0);
        }
        return 0;
    };
    var totalArticleCount = sumTotalArticleCount();
    var sharedGA4args = useMemo(function () { return ({
        context: trackingContext || getGA4Context({ isCrossCampaign: true }),
    }); }, [trackingContext]);
    return (React.createElement(TranslateScope, { path: translationScope }, isCategorySelected && (React.createElement(CategoryList, { allCategories: selectableCategories, availableCategories: selectableCategories, selectedCategories: selectedCategoriesIds, campaign: null, setVisibilityFilter: setVisibilityFilterMultiCategorySelect, showCategoriesModal: true, updateFilter: updateFilter, totalArticlesCount: totalArticleCount, isResetHidden: true, isRootCategoryToggleDisabled: isRootCategoryToggleDisabled, isCrossCampaign: true, isMyLoungeCrossCampaignEntry: true, updateCategoriesFilter: handleSelectedCategories, preExpandedCategories: preExpandedCategories, sharedGA4args: sharedGA4args }))));
};
